import React from 'react';
import { Route } from 'react-router-dom';
import { LoginCallback } from '@okta/okta-react';
import Logout from './Logout';

const AuthRoutes = () => [<Route key="login_callback" path="/login/callback" component={LoginCallback} />, <Route key="logout" path="/logout" component={Logout} />];

export default AuthRoutes;
